module.exports = __webpack_public_path__ + "static/img/airoad_banner@2x.ccbc9336.png";